import * as React from "react";

import {
  PropertyUnitListView as SharedUiPropertyUnitListView,
  ListingsHeader as SharedUiListingsHeader,
} from "@shared-ui/lodging-property-offers";
import { UitkSpacing } from "uitk-react-spacing";

import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { RefTarget } from "@shared-ui/ref-context";
import { Viewport, ViewMedium, ViewSmall } from "@shared-ui/viewport-context";
import { MobileForm, DesktopForm } from "src/components/shared/DatePickerAndTravelerForm/Form";
import { StackedSticky } from "components/shared/StackedSticky/StackedSticky";

const WrappedPropertyUnitListView = PropertyBexApiWrapper(SharedUiPropertyUnitListView);
const WrappedListingsHeader = PropertyBexApiWrapper(SharedUiListingsHeader);

export const PropertyUnitListView = (props: ComponentProps) => {
  const { context } = props;

  return (
    <UitkSpacing margin={{ block: "three" }}>
      <RefTarget name="Offers" tag="section" dataStid="section-hotel-search">
        <WrappedListingsHeader context={context} />
        <Viewport>
          <ViewSmall>
            <MobileForm context={context} />
          </ViewSmall>
          <ViewMedium>
            <StackedSticky padded>
              <DesktopForm context={context} />
            </StackedSticky>
          </ViewMedium>
        </Viewport>
        <WrappedPropertyUnitListView context={context} />
      </RefTarget>
    </UitkSpacing>
  );
};

export default PropertyUnitListView;
